import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { checkVietNam } from '@src/utils/checkCountry';
import { PACKAGE_CODE, PRODUCT_TYPE } from '@src/constants/package';
import { VBEE_CONSOLE_URL } from '@src/configs';
import route from '@src/constants/route';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import LogoAIVoiceAPI from '@src/assets/logo/small-logo-api.svg';
import LogoAIVoiceDubbing from '@src/assets/logo/small-logo-dubbing.svg';
import LogoAIVoice from '@src/assets/logo/small-logo.svg';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { StyledHome } from './index.style';
import VoiceList from './VoiceList';
import { GLOBAL_SAMPLE_AUDIOS, VN_SAMPLE_AUDIOS } from './sampleAudiosData';

const NewHomePage = () => {
  const { t } = useTranslation();

  const [voiceList, setVoiceList] = useState([]);

  const handelChangeVoiceList = (voices) => setVoiceList(voices);

  const PRODUCT_LIST = [
    {
      type: PRODUCT_TYPE.aivoiceStudio,
      name: t('STUDIO'),
      value: t('convertDocToVoice'),
      description: t('descriptionProductAIvoiceStudio'),
      logo: LogoAIVoice,
    },
    {
      type: PRODUCT_TYPE.aivoiceApi,
      name: t('API'),
      value: t('forDeveloper'),
      description: t('descriptionProductAIvoiceapi'),
      logo: LogoAIVoiceAPI,
    },
    {
      type: PRODUCT_TYPE.aivoiceDubbing,
      name: t('DUBBING'),
      value: t('convertSubtitleToDubbingVoice'),
      description: t('descriptionProductAIvoiceDubbing'),
      logo: LogoAIVoiceDubbing,
    },
  ];

  const { user } = useSelector((state) => state.auth);

  const history = useHistory();

  const isVietNam = checkVietNam();

  const getSampleVoices = () => {
    const { packageCode } = user;
    const isFreeUser = packageCode === PACKAGE_CODE.STUDIO_FREE;

    if (isVietNam || isFreeUser) return VN_SAMPLE_AUDIOS;
    return GLOBAL_SAMPLE_AUDIOS;
  };

  const handleChooseProduct = (product) => {
    const { type } = product;
    switch (type) {
      case PRODUCT_TYPE.aivoiceStudio: {
        history.push(route.TTS);
        break;
      }
      case PRODUCT_TYPE.aivoiceDubbing: {
        history.push(route.HOME_DUBBING);
        break;
      }
      case PRODUCT_TYPE.aivoiceApi: {
        window.location.href = VBEE_CONSOLE_URL;
        break;
      }
      default:
        break;
    }
  };

  useEffect(() => {
    setVoiceList(getSampleVoices());
  }, [user]);

  const { getFeatureValue } = useFeatureFlags();
  const useBannerHomepage = getFeatureValue(FEATURE_KEYS.BANNER_HOMEPAGE, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const isNewVoiceList = getFeatureValue(FEATURE_KEYS.NEW_VOICES_LIST, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });
  const isNewProductList = getFeatureValue(FEATURE_KEYS.NEW_PRODUCTS_LIST, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  return (
    <StyledHome>
      <div>
        <p className="title-header">{t('welcome')}</p>
        <div className="banner">
          <p className="banner-title">{useBannerHomepage.title}</p>
          <p className="banner-subtitle">{useBannerHomepage.subtitle}</p>
        </div>
      </div>
      {isNewVoiceList && (
        <div className="section-new">
          <VoiceList
            title={t('discoverVoiceovers')}
            subtitle={t('exploreProfessionalVoiceovers')}
            voiceList={voiceList}
            onChangeVoiceList={handelChangeVoiceList}
          />
        </div>
      )}
      {isNewProductList && (
        <div className="section-new">
          <span className="title">{t('startCreateContent')}</span>
          <p className="subtitle">{t('selectProductAndUse')}</p>

          <div className="new-other-product-wrapper">
            {PRODUCT_LIST.map((product) => (
              <div
                className="other-product-box"
                key={product.type}
                onClick={() => handleChooseProduct(product)}
                tabIndex={0}
                role="button"
              >
                <div className="product-info">
                  <div className="logo-name">
                    <img src={product.logo} alt="arrow" className="logo" />
                    <span className="name">{product.name}</span>
                  </div>
                  <div>
                    <span className="description">{product.description}</span>
                  </div>
                </div>
                <IconButton
                  className="button"
                  onClick={() => handleChooseProduct(product)}
                >
                  <AddRoundedIcon />
                </IconButton>
              </div>
            ))}
          </div>
        </div>
      )}
    </StyledHome>
  );
};

export default NewHomePage;
